import { Logo } from "./Logo";
import { Instagram } from "lucide-react";
import { INSTAGRAM_URL, INSTAGRAM_HANDLE } from "../lib/social";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="border-t border-[#E5E0D8]">
      <div className="px-6 md:px-12 lg:px-24 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-2">
          <Logo size={48} />
          <p className="mt-6 text-sm text-[#555] max-w-md leading-relaxed">
            A curated portal connecting collectors with contemporary masters working across the African continent
            and its diaspora.
          </p>
        </div>
        <div>
          <p className="label-eyebrow text-[#555] mb-4">Explore</p>
          <ul className="space-y-2 text-sm">
            <li><a href="/gallery" className="hover:text-[#1E3A8A]">Gallery</a></li>
            <li><a href="/auctions" className="hover:text-[#1E3A8A]">Auctions</a></li>
            <li><a href="/artists" className="hover:text-[#1E3A8A]">Artists</a></li>
            <li><a href="/journal" className="hover:text-[#1E3A8A]">African Stories</a></li>
            <li><a href="/events" className="hover:text-[#1E3A8A]">Events</a></li>
            <li><a href="/p/faq" className="hover:text-[#1E3A8A]">FAQ</a></li>
            <li><a href="/p/shipping" className="hover:text-[#1E3A8A]">Shipping</a></li>
            <li><a href="/p/terms" className="hover:text-[#1E3A8A]">Terms</a></li>
            <li>
              <a
                href={`${process.env.REACT_APP_BACKEND_URL}/api/flyer/site`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-download-flyer"
                className="hover:text-[#1E3A8A]"
              >
                Download flyer (PDF)
              </a>
            </li>
          </ul>
        </div>
        <div>
          <p className="label-eyebrow text-[#555] mb-4">Contact</p>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="mailto:sales@africaartmasters.com" className="hover:text-[#1E3A8A]">
                sales@africaartmasters.com
              </a>
            </li>
            <li>
              <a href="tel:+353857369925" className="hover:text-[#1E3A8A]">
                +353 (0) 85 736 9925
              </a>
            </li>
            <li>
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                className="inline-flex items-center gap-2 hover:text-[#1E3A8A]"
              >
                <Instagram className="w-4 h-4" strokeWidth={1.5} />
                {INSTAGRAM_HANDLE}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E5E0D8] px-6 md:px-12 lg:px-24 py-6 flex justify-between label-eyebrow text-[#555]">
        <span>© 2026 AfricaArtMasters</span>
        <span>Harare · Johannesburg · Lusaka</span>
      </div>
    </footer>
  );
};
